import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: process.env.VUE_APP_LOCALE ? process.env.VUE_APP_LOCALE : 'en',
    fallbackLocale: 'en',
    messages: {
        en: require('@/i18n/en.json'),
        fr: require('@/i18n/fr.json')
    }
})

export default i18n
